import { Link } from 'react-router-dom';
import { ProductCard } from '../ui/ProductCard';
import { Button } from '../ui/Button';
import products from '../../data/products.json';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useScrollAnimation, useStaggeredAnimation } from '../../hooks/useScrollAnimation';

export function FeaturedProducts() {
  const featuredProducts = products
    .filter(p => p.badges.includes('bestseller'))
    .sort((a, b) => {
      if (a.isPackage) return -1;
      if (b.isPackage) return 1;
      return 0;
    })
    .slice(0, 4);

  const { ref: headerRef, inView: headerInView } = useScrollAnimation();
  const { ref: gridRef, visibleItems } = useStaggeredAnimation(featuredProducts.length, 120);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div
          ref={headerRef}
          className={`flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12 scroll-hidden ${headerInView ? 'scroll-visible' : ''}`}
        >
          <div>
            <span className="section-tag">
              <Sparkles className="w-4 h-4" />
              Best Sellers
            </span>
            <h2 className="section-heading">
              Most Loved Products
            </h2>
            <p className="section-subheading">
              Our highest rated herbal formulations, trusted by thousands of customers
            </p>
          </div>
          <Link
            to="/shop"
            className="flex items-center gap-2 text-primary font-semibold hover:gap-3 transition-all duration-300 whitespace-nowrap group"
          >
            View All Products
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
          </Link>
        </div>

        {/* Product grid with stagger */}
        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuredProducts.map((product, index) => (
            <div
              key={product.id}
              className={`scroll-hidden ${visibleItems.includes(index) ? 'scroll-visible' : ''}`}
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <ProductCard product={product} />
            </div>
          ))}
        </div>

        {/* CTA row */}
        <div className={`text-center mt-12 scroll-hidden ${headerInView ? 'scroll-visible' : ''}`} style={{ transitionDelay: '400ms' }}>
          <Link to="/shop">
            <Button variant="outline" size="lg" rightIcon={<ArrowRight className="w-5 h-5" />}>
              Browse All {products.length} Products
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}